import { render } from "./PreviewFrame.vue?vue&type=template&id=2df7297c&scoped=true"
import script from "./PreviewFrame.vue?vue&type=script&lang=js"
export * from "./PreviewFrame.vue?vue&type=script&lang=js"

import "./PreviewFrame.vue?vue&type=style&index=0&id=2df7297c&lang=scss&scoped=true"
import "./PreviewFrame.vue?vue&type=style&index=1&id=2df7297c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df7297c"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QTooltip,QScrollArea});
